<template>
  <el-dialog
      :visible.sync="isShow"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="480px"
      custom-class="titleDialog"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <img :src="$utils.getPng('web4/icon-circle-fill')"/>
          <span>{{ title }}</span>
        </div>
        <fm-button @click="handleClose" type="info" size="mini" text icon="icon-model-close"></fm-button>
      </div>
      <div class="d-content">
        <p class="title">{{ subTitle }}</p>
        <div style="font-size: 16px;" class="txt">
          {{ text }}
        </div>
      </div>
      <div class="d-footer">
        <fm-button type="primary" size="small" @click="handleConfirm" :disabled="btnDis">{{ confirm }}</fm-button>
        <fm-button @click="handleClose" type="info" plain size="small">取 消</fm-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name:'title',
  props:{
    isShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '提示'
    },
    subTitle: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    confirm:{
       type: String,
      default: '确 定'
    }
  },
  watch:{
    isShow(val){
      if(val){
        this.btnDis = false
      }
    }
  },
  data(){
    return{
      btnDis:false
    }
  },
  methods:{
    handleClose(){
      this.$emit('handleClose')
    },
    handleConfirm() {
      if (this.btnDis) return;
      this.$emit('handleConfirm')
    }
  }
}
</script>

<style lang="scss">
@import "./dialog.scss";
</style>
